/**
 * Colores de las gráficas de los dashboards, siempre como tokens.
 *
 * El color sigue a la ENTIDAD, nunca a su posición: «entregado» es el mismo
 * verde en el informe del evento, en el del proyecto y en Insights, aunque
 * en una pantalla falte «caducado». Las paletas categóricas se validaron con
 * el validador del skill dataviz sobre la superficie clara (separación CVD,
 * banda de luminosidad, croma). Lo que no es categoría —lo que queda en la
 * caja, la pista de fondo— va en neutro y fuera de la paleta.
 */

/** Destino de cada unidad del libro de premios, en orden fijo. */
export const SEGMENT_KEYS = ['delivered', 'pending', 'lapsed', 'returned', 'unaccounted'] as const;
export type SegmentKey = (typeof SEGMENT_KEYS)[number];

export const SEGMENT_COLORS: Record<SegmentKey, string> = {
  delivered: 'var(--color-dash-olive)',
  pending: 'var(--color-dash-amber)',
  lapsed: 'var(--color-dash-teal)',
  returned: 'var(--color-dash-gray)',
  unaccounted: 'var(--color-dash-red)',
};

/** Texto que va DENTRO de un segmento, si cabe. */
export const SEGMENT_INK: Record<SegmentKey, string> = {
  delivered: '#ffffff',
  pending: '#3a2a00',
  lapsed: '#ffffff',
  returned: '#3f3f3a',
  unaccounted: '#ffffff',
};

/** Lo que aún no salió del juego: la pista, no una categoría. */
export const TRACK_COLOR = 'var(--color-dash-track)';

/** Fases de la ventana de captura, en orden temporal. */
export const PHASE_COLORS = {
  warmup: 'var(--color-dash-olive-dim)',
  peak: 'var(--color-dash-lime)',
  tail: 'var(--color-dash-amber)',
} as const;

/** Barras por evento: lo que ya cerró frente a lo que está en marcha. */
export const EVENT_COLORS = {
  done: 'var(--color-dash-olive-dim)',
  live: 'var(--color-dash-lime)',
  upcoming: 'var(--color-dash-gray)',
} as const;

export const CHART_TOOLTIP_STYLE = {
  backgroundColor: 'var(--color-bg-surface)',
  border: '1px solid var(--color-border-default)',
  borderRadius: 'var(--radius-lg)',
  fontSize: 12,
  color: 'var(--color-fg-primary)',
} as const;
